<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";

const rules = [
  "Sentence end par full stop use hota hai.",
  "List ya pause ke liye comma use hota hai.",
  "Direct question ke end par question mark lagta hai.",
  "Strong feeling ke liye exclamation mark use hota hai.",
  "Proper quotation me inverted commas use hoti hain.",
];

const correctionTips = [
  "Paragraph pehle full read karo phir punctuation insert karo.",
  "Capital letter aur full stop ko sath check karna useful hota hai.",
  "Dialogue ya quoted words hon to commas aur inverted commas par focus karo.",
];

const example = {
  wrong: "ali said i am ready are you coming with me",
  correct: "Ali said, \"I am ready. Are you coming with me?\"",
};

const moreExamples = [
  {
    wrong: "what is your name",
    correct: "What is your name?",
  },
  {
    wrong: "hurrah we have won the match",
    correct: "Hurrah! We have won the match.",
  },
];

const commonMistakes = [
  "Capital letter se sentence start na karna.",
  "Question sentence ke end par question mark bhool jana.",
  "Dialogue me commas aur inverted commas omit kar dena.",
];

usePageSeo({
  title: "11th Class English Punctuation | Rules, Correction, Examples",
  description: "11th class English punctuation page with core rules, correction examples, common mistakes and board-style punctuation practice.",
  keywords: "11th class english punctuation, class 11 punctuation rules, english grammar punctuation, punctuation correction examples",
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
    { name: "Grammar", item: "/11th/english/grammar/" },
    { name: "Punctuation", item: "/11th/english/grammar/punctuation/" },
  ],
});
</script>

<template>
  <PageContainer>
    <EnglishHero
      headline="Grammar Task"
      title="Punctuation"
      description="Yeh page board-style punctuation correction ke liye basic rules aur checking strategy deta hai."
    />

    <EnglishSection title="Core Rules" description="Use these rules as the base layer for punctuation correction.">
      <EnglishGrid>
        <EnglishCard v-for="item in rules" :key="item" title="Rule" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Correction Tips" description="These help when you need to fix punctuation in a full sentence or paragraph.">
      <EnglishGrid>
        <EnglishCard v-for="item in correctionTips" :key="item" title="Tip" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Mini Correction Example" description="A compact before/after example of punctuation correction.">
      <EnglishCard :title="`Wrong: ${example.wrong}`" :description="`Correct: ${example.correct}`" />
    </EnglishSection>

    <EnglishSection title="More Correction Examples" description="Use these examples to see how punctuation changes sentence meaning and clarity.">
      <EnglishGrid>
        <EnglishCard v-for="item in moreExamples" :key="item.wrong" :title="`Wrong: ${item.wrong}`" :description="`Correct: ${item.correct}`" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Common Mistakes" description="These are the errors students most often make in punctuation questions.">
      <EnglishGrid>
        <EnglishCard v-for="item in commonMistakes" :key="item" title="Mistake" :description="item" />
      </EnglishGrid>
    </EnglishSection>
  </PageContainer>
</template>
